import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { DataDemoBadge, CompletenessBar } from "@/components/DataBadge";
import { formatRupiah, CATEGORY_LABEL } from "@/lib/format";
import { Gauge, Battery, Route } from "lucide-react";

export function VehicleCard({ v, onClick, footer }) {
  const navigate = useNavigate();
  const handle = onClick || (() => navigate(`/kendaraan/${v.vehicle_id}`));
  return (
    <Card
      data-testid={`vehicle-card-${v.vehicle_id}`}
      onClick={handle}
      className="overflow-hidden rounded-2xl border border-border bg-white cursor-pointer transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)]"
    >
      <div className="relative h-40 bg-secondary flex items-center justify-center">
        {v.image ? (
          <img src={v.image} alt={`${v.brand} ${v.model}`} className="w-full h-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; const fb = e.currentTarget.parentNode.querySelector("[data-fallback]"); if (fb) fb.style.display = "flex"; }} />
        ) : null}
        <div data-fallback className="absolute inset-0 items-center justify-center text-muted-foreground text-sm" style={{ display: v.image ? "none" : "flex" }}>Tanpa foto</div>
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className="bg-navy text-white hover:bg-navy border-0">{CATEGORY_LABEL[v.category] || v.category}</Badge>
          <DataDemoBadge status={v.data_status} />
        </div>
      </div>
      <div className="p-4 space-y-3">
        <div>
          <p className="text-xs text-muted-foreground">{v.brand}</p>
          <h3 className="font-heading font-bold text-navy text-lg leading-tight">{v.model}</h3>
        </div>
        <p className="text-teal font-heading font-extrabold text-xl">{formatRupiah(v.official_price)}</p>
        {v.price_max_idr != null && v.price_min_idr != null && v.price_max_idr > v.price_min_idr && (
          <p className="text-xs text-muted-foreground -mt-1" data-testid="price-range">Rentang pasar: {formatRupiah(v.price_min_idr)} – {formatRupiah(v.price_max_idr)}</p>
        )}
        <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
          {v.motor_nominal_w != null && <span className="inline-flex items-center gap-1"><Gauge className="w-3.5 h-3.5" />{v.motor_nominal_w} W</span>}
          {v.claimed_range_km != null && <span className="inline-flex items-center gap-1"><Route className="w-3.5 h-3.5" />{v.claimed_range_km} km</span>}
          {v.battery_capacity_kwh != null && <span className="inline-flex items-center gap-1"><Battery className="w-3.5 h-3.5" />{v.battery_capacity_kwh} kWh</span>}
        </div>
        <CompletenessBar value={v.specification_completeness} />
        {footer}
      </div>
    </Card>
  );
}
